import {
  StatsState,
  StatsActionTypes,
  SET_CURRENT_ROUTE,
  SET_PREV_ROUTE,
} from './types';

const initialState: StatsState = {
  currentRouteTitle: '',
  currentRouteUrl: '',
  prevRouteTitle: '',
  prevRouteUrl: '',
};

export function statsReducer(
  state: StatsState = initialState,
  action: StatsActionTypes
): StatsState {
  switch (action.type) {
    case SET_CURRENT_ROUTE:
      return {
        ...state,
        currentRouteTitle: action.title,
        currentRouteUrl: action.url,
      };
    case SET_PREV_ROUTE:
      return {
        ...state,
        prevRouteTitle: action.title,
        prevRouteUrl: action.url,
      };
    default:
      return state;
  }
}
